import { gql } from '@apollo/client';

export const ADMIN_GET_DASHBOARD_ACCOUNT_ACCESS = gql`
  query DashboardAccountAccess {
    externalDashboards {
      result: externalDashboardsAccessByAccountAdmin {
        error
        success
        entity {
          byAccount {
            id
            accountId
            accountName
            dashboardId
          }
          byAccountType {
            dashboardId
            accountTypes
          }
        }
      }
    }
  }
`;
